import { atom } from 'jotai';

const HeaderSegmentedControlAtom = atom<string | undefined>(undefined);

const headerSegmentedControlValueAtom = atom((get) => get(HeaderSegmentedControlAtom));
const setHeaderSegmentedControlAtom = atom(null, (get, set, params: string) =>
  set(HeaderSegmentedControlAtom, params)
);

export { headerSegmentedControlValueAtom, setHeaderSegmentedControlAtom };
